import React, { useState, useContext, useEffect,useRef } from 'react';
import styles from './style/index.module.less';
import { Link,useHistory,useLocation } from 'react-router-dom';
import axiosInstance from '@/utils/axiosInstance';
import {
  Badge
} from '@arco-design/web-react';
export interface TopListItemData {
  name: string;
  router: string;
  /** 是否在导航文字右上角展示 NEW 小标 */
  isNew?: boolean;
}

interface TopListProps {
  data: TopListItemData[];
  children: React.ReactNode;

}
const roleMold = localStorage.getItem("role");
function TopList(props: TopListProps) {
	const menuKey = localStorage.getItem("menuKey");
	const location = useLocation();
	const str = location.pathname;
	const regex = /\/([^/]+)\//;
	const match = str.match(regex)?str.match(regex):'index';
	const locaResult = match[1];
	const { data } = props;
	const def = menuKey?data[menuKey]['name']:'首页'
	const [active, setActive] = React.useState(def);
	const [verifyNum,setverifyNum] = React.useState(0);
	const systemType = localStorage.getItem("systemType");
	React.useEffect(()=>{
		setActive(def);
	},[menuKey])
	
	

	
	React.useEffect(()=>{
		if(roleMold=='3'){
			leverGetVerifyNum();
			const timer = setInterval(() => {
				leverGetVerifyNum();
			},30000);
			return () => clearTimeout(timer);
		}
	},[])
	const audio_verify_num = useRef(0)
	function leverGetVerifyNum(){
		axiosInstance.get('/lever/get_verify_num',{
	
		})
		.then((res) => {
		 	const { code, msg } = res.data;
		 	if (res.data.code === 0) {
				setverifyNum(res.data.data.verify_num)
				
				if(res.data.data.verify_num>0){
					if(audio_verify_num.current!=res.data.data.verify_num){
						audio_verify_num.current = res.data.data.verify_num
						togglePlay();
					}
				}else{
					audioRef.current.pause();
					
				}
		 	}
		})
	}
		const playCount = useRef(0);
		const audioRef = useRef(null);

		const togglePlay = () => {
			
			audioRef.current.play().then(() => {
				playCount.current = playCount.current + 1;
			}).catch(error => {
				console.log('error',error);
				audio_verify_num.current = 0
			})
		};
	
	  const handleEnded = () => {
	    // 当声音播放结束时，将 currentTime 设置为 0，实现循环播放
		if (playCount.current < 5) {
			audioRef.current.currentTime = 0;
			audioRef.current.play().then(() => {
				console.log('playCount',playCount.current);
			}).catch(error => {
				console.log('error1',error);
				audio_verify_num.current = 0
			})
			playCount.current = playCount.current + 1;
		} else {
			playCount.current = 0;
			audioRef.current.pause();
		}
		
		
	
	  };

	

	//   const [audio] = useState(new Audio(src));
	
	//   useEffect(() => {
	//     audio.loop = true; // 设置音频循环播放
	//     audio.play();
	
	//     return () => {
	//       audio.pause();
	//     };
	//   }, [audio]);

	//};
	
	return (
		<div className={styles.topBox} >
		      <audio ref={audioRef} src={'https://haitzhitou.oss-cn-shanghai.aliyuncs.com/feed/y2282.mp3'} onEnded={handleEnded} />
		     
		{/* <Menu mode='horizontal' defaultSelectedKeys={['1']}>
			<MenuItem
			  key='0'
			  style={{ padding: 0, marginRight: 38, }}
			  disabled
			>
			  <div
				style={{
				  width: 80,
				  height: 30,
				  borderRadius: 2,
				  background: 'var(--color-fill-3)',
				  cursor: 'text',
				}}
			  />
			</MenuItem>
			<MenuItem key='1'>Home</MenuItem>
			<MenuItem key='2'>Solution</MenuItem>
			<MenuItem key='3'>Cloud Service</MenuItem>
			<MenuItem key='4'>Cooperation</MenuItem>
		</Menu>*/}
			{data.map((item, index) => (
			<React.Fragment key={index}>
				{item.name=='学习中心'?(
					<div className={styles['topBox-nav']}>
						{Number(systemType)==1?(
							<a  style={{color: 'inherit' }} href="https://wwzxnqwscdk.feishu.cn/wiki/A8AXwC8U2iXLIQkefxYc2agXnbe?from=from_copylink" rel="noreferrer"  target="_blank">
								<span style={{fontWeight:'bold'}}>{item.name}</span>
							</a>
						
						):(
							<a  style={{color: 'inherit' }} href="http://6-w.cn/wBzk" rel="noreferrer"  target="_blank">
								<span style={{fontWeight:'bold'}}>{item.name}</span>
							</a>
						)}
					</div>
				):(
					// <Link 	className={item.router.includes(locaResult)?styles['topBox-nav']+' '+styles['active']:styles['topBox-nav']}
					<Link 	className={item.router.startsWith('/'+locaResult+'/')?styles['topBox-nav']+' '+styles['active']:styles['topBox-nav']}
							key={index} 
							to={
								{ pathname: item.router,
								  state: { }
								}
							}
							onClick={()=>handleClick(index,item.name)}
							  >	
							  {item.name=='杠杆审核'?(
								<Badge count={verifyNum} offset={[15, -2]}>
									<span style={{fontWeight:'bold'}}>{item.name}</span>
								</Badge>
							  ):(
								<>
									<span style={{fontWeight:'bold'}}>{item.name}</span>
									{item.isNew && <span className={styles['new-tag']}>NEW</span>}
								</>
							  )}
							 
					</Link>
				)}
				
				
				</React.Fragment>
				
				
			))}
		</div>
	);
	function handleClick(index,name){
	
		localStorage.setItem('menuKey', index);
		setActive(name);
	}
}


export default TopList;
